module.exports = __webpack_public_path__ + "media/images/players/SMITH_CAMERON-34706113a5243d9b6b983d8e10872863.png";